/*!
 * @copyright
 * Copyright(c) 2019 SICK AG
 */

import { run } from './pip';

run(document.getElementById('viewer'));
